import { useState } from "react"
import { 
  Box,
  Link,
  AppBar,
  Toolbar,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import Connect from "components/Connect"
import { NOT_LIVE_YET } from "config"
import useWindowSize from "hooks/useWindowSize"

const items = NOT_LIVE_YET ? [{
  label: "About Us",
  url: "/about-us",
  enabled: true
}] : [
  {
    label: "Projects",
    url: "/projects",
    enabled: true
  },
  {
    label: "About Us",
    url: "/about-us",
    enabled: true
  }
]

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false)
  const windowSize = useWindowSize()

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const isMobile = windowSize.width < 1100;

  const discordURL = 'https://discord.gg/concentricart';
  const twitterURL = 'https://twitter.com/Concentric_Art';

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{textAlign: "center"}}>
      <List dense>
        {items.map((item) => (
          <ListItem sx={{"&:hover": {backgroundColor: "#f5f5f5"}}} key={item.label} disablePadding>
            <ListItemButton component={Link} href={item.url} sx={{textAlign: "left", pointerEvents: item.enabled ? "auto" : "none"}}>
              <ListItemText primary={item.label} primaryTypographyProps={{fontSize: 18, fontWeight: 600, color: item.enabled ? "black" : "lightgrey"}}/>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  )
  return (
    <Box sx={{width: "100%", display: "flex", justifyContent: "center", backgroundColor: "black"}}>
      <AppBar component="nav" position="static" elevation={1} sx={{backgroundColor: "black", boxShadow: 0}}>
        <Toolbar sx={{width: "100%", display: "flex", margin: "auto", justifyContent: "space-between", backgroundColor: "white"}}>
          <Box sx={{display: "flex", backgroundColor: "white", justifyContent: "center", alignItems: "center"}}>
            <IconButton
              color="default"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{mr: 2, display: {sm: "none"}}}>
              <MenuIcon/>
            </IconButton>
            <Box sx={{paddingRight: "25px"}}>
              <Link href="/" sx={{display: "flex"}}>
                <img src="/media/logo.svg" alt="artblocks" height={26}></img>
              </Link>
            </Box>
            <Box sx={{display: {xs: "none", sm: "block"}, marginTop: "5px"}}>
              {items.map((item) => (
                  <Link 
                  key={item.label} 
                  href={item.url} 
                  underline="hover"
                  sx={{fontSize: 18, fontWeight: 600, color: item.enabled ? "black" : "lightgrey", paddingRight: "25px", pointerEvents: item.enabled ? "auto" : "none"}}>
                  {item.label}
                </Link>
              ))}
            </Box>
          </Box>
          <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
            <Box sx={{marginTop: '7px', marginRight: isMobile ? '7px' : '20px', marginLeft: isMobile ? '7px' : '0px'}}>
              <a target='_blank' rel='noreferrer' href={twitterURL}>
                <img
                  onClick={() => {
                    window.open(twitterURL)
                  }}
                  style={{height:'22px',width:'22px',alignItems:'center',justifyContent:'center'}}
                  src={'/media/twitter_icon.svg'} />
              </a>
            </Box>
            <Box sx={{marginTop: '5px', marginRight: isMobile ? '7px' : '20px', marginLeft: isMobile ? '7px' : '0px'}}>
              <div>
                <a target='_blank' rel='noreferrer' href={discordURL}>
                  <img
                    onClick={() => {
                      window.open(discordURL)
                    }}
                    style={{height:'22px',width:'22px'}}
                    src={'/media/discord.svg'} />
                </a>
              </div>
            </Box>
            {NOT_LIVE_YET ? (null) : (<Connect/>)}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{keepMounted: true}}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: 240
            }
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  )
}

export default Header